// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4df0fa2","239":"91a272c5","488":"983de6a7","667":"77b621cc"}[chunkId] + ".chunk.js";
};